import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CreatorCommunityRoute extends DiscourseRoute {
  @service communityNavigation;
  @service communityNavigationNotices;
  @service store;

  queryParams = {
    order: { refreshModel: true },
  };

  async beforeModel(transition) {
    const tree = await this.communityNavigation.load();
    const creator = tree.primary.find((item) => item.key === "creator");
    if (creator?.access_restricted) {
      transition.abort();
      this.communityNavigationNotices.showCreatorAccessRequired();
    }
  }

  async model({ order = "latest" }) {
    const topicList = await this.store.findFiltered("topicList", {
      filter: "community-navigation/topics",
      params: { section: "creator", order, page: 0 },
    });
    return {
      topicList,
      order,
      title: i18n("community_navigation.creator_community"),
    };
  }

  titleToken() {
    return i18n("community_navigation.creator_community");
  }
}
